// extracted by mini-css-extract-plugin
module.exports = {"cover":"Palet_cover__P5nCR","container":"Palet_container__1npXU","pen":"Palet_pen__h_e4S","penSizeArea":"Palet_penSizeArea__1nBzJ"};